<template>
<div class="container-fluid">
    <div class="card card-primary card-outline">
        <div class="card-body">
            <div class="callout callout-danger" style="display:none" id="screenPermission">
                <h5 class="bg-gradient-danger">Sorry!</h5>
                <div id="messages"></div>
            </div>
            <div class="form-group" id="main_form">
                <div class="p-2 mb-1 bg-info text-white">
                    <label > <b >Personal Details</b></label>
                </div>
                <div class="row form-group">
                    <template v-if="!is_student">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >CID No/Reference  : </label>
                            <label class="text-primary">{{std_admission_details.CidNo}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Name of Student :</label>
                            <label class="text-primary">{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Gender :</label>
                            <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                        </div>
                    </template>
                    <template v-else>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <label class="required" >CID No/Reference  : </label>
                                <label class="text-primary">{{std_admission_details.CidNo}}</label>
                            </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Name of Student :</label>
                            <label class="text-primary">{{ std_admission_details.Name}} </label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <label class="required" >Gender :</label>
                            <label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
                        </div>
                        
                    </template>
                </div>
                <div class="row form-group">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >Date of Birth :</label>
                        <label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Date of Apply :</label>
                        <label class="text-primary">{{ std_admission_details.DateOfApply}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Class :</label>
                        <label class="text-primary">{{ std_admission_details.class_id}}</label>
                    </div>
                </div>
                <hr>
                <div class="row form-group" id="present_school">
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label class="required" >Dzongkhag/Thromde : </label>
                        <label class="text-primary">{{this.student_form.dzongkhagName}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label >School : </label>
                        <label class="text-primary">{{ this.std_present_school }} {{this.level}}</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <label>Class : </label>
                        <label class="text-primary"><span id="present_class"></span>{{this.std_present_class}}</label>
                    </div>
                </div>
                <div class="form-group" >
                    <div class="p-2 mb-1 bg-info text-white">
                        <label > <b >Parents/Guardian Details</b></label>
                    </div>
                <div class="form-group table-responsive">
                    <table id="list-student-left" class="table table-bordered table-striped table-head-fixed">
                        <thead>
                            <tr>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>No.</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Name</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Relation</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>CID</th>
                                <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Working Address</th>
                                <th >Residence Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, count) in parents_details" :key="count">
                                <td>{{ count + 1 }} </td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.Relationship }}</td>
                                <td>{{ item.CidNo }}</td>
                                <td>{{ item.WorkAddress }}</td>
                                <td>{{ item.ResidenceAddress }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="card card-primary card-outline">
        <div class="card-body">
            <div class="form-group">
                <label><b>Apply for Admission</b></label>
            <hr>
                <template v-if="!is_student">
                    <div class="row form-group" id="admissiontype">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                            <label class="required" >Admission For:<span class="text-danger">*</span></label>
                            <input type="radio" v-model="student_form.admission_type" name="registrationType" @click="showsection('ECCD')" value="ECCD" id="new"> ECCD
                            <input type="radio" v-model="student_form.admission_type" name="registrationType" @click="showsection('PP')" value="PP" id="existing" class="ml-4"> Class PP - XII(Except Class XI Admission)
                            <!-- <input type="radio" name="registrationType" @click="showsection('Abroad')" value="Abroad" id="existing" class="ml-4"> Non-Registered Students (No Student Id) -->
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row form-group">
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                            <label class="required" >Admission For:<span class="text-danger">*</span></label>
                            <input type="radio" name="registrationType" @change="getParentSchoolDzo()" @click="showsection('ParentSchool')" value="ParentSchool" id="existing" class="ml-4"> Transfer to Parent School
                            <input type="radio" name="registrationType" @change="getdzongkhagList('Student')" @click="showsection('NonParentSchool')" value="NonParentSchool" id="existing" class="ml-4" checked> Transfer to Non-Parent School <br>
                            <small><i>(*Note: If present school is registered as a feeder school, then Parent School guarantees admission)</i></small>
                        </div>
                    </div>
                </template>
                <div class="row form-group">
                    <div class="callout callout-danger" style="display:none" id="validationmessages">
                        <h5 class="bg-gradient-danger">Sorry!</h5>
                        <div id="validation_message"></div>
                    </div>
                    <div class="card-body col-lg-12 col-md-12 col-sm-12 col-xs-12 table-responsive  " style="display:none" id="selectschool">
                        <table id="dynamic-table" class="table table-sm table-bordered table-striped">
                            <thead class="p-3 mb-2 bg-info text-white border border-info">
                                <tr>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' class="text-start">Dzongkhag/Thromde</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' class="text-start">School/ECCD Centres</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' class="text-start">Class/Age group</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' class="text-start">School Decision</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' class="text-start">Student Decision</th>
                                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif' id="actionButtonHeader">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id="record1" v-for='(item, index) in response_data' :key="index">
                                    <td v-if="item.OrgOrganizationId">
                                        {{dzongkhagArray[item.Dzongkhagid]}}
                                    </td>
                                    <td v-if="item.organization || item.OrgOrganizationId">
                                        {{item.organization.name}}
                                    </td>
                                    <td v-if="std_class && item.OrgOrganizationId" >
                                        {{std_class}}
                                    </td>
                                    <td v-if="item.OrgOrganizationId"><span class="badge badge-success">{{item.school_decision==null ? 'Pending' : item.school_decision}} </span></td>
                                    <td v-if="item.OrgOrganizationId"><span class="badge badge-success">{{item.student_decision==null ? 'Pending' : item.student_decision}}</span> </td>
                                    <td id="actionButton" v-if="item.OrgOrganizationId">
                                        <template v-if="item.school_decision=='Accepted' && item.student_decision!='Accepted' && item.student_decision!='Rejected'">
                                            <button type="button" class="btn btn-flat btn-sm btn-primary" id="remove" @click="remove('Accepted',item.id)"><i class="fa fa-check"></i> Accept</button>
                                            <button type="button" class="btn btn-flat btn-sm bg-danger" id="remove" @click="remove('Rejected',item.id)"><i class="fa fa-times pr-2"></i> Reject</button>
                                        </template>
                                        <button v-if="item.school_decision=='' || item.school_decision==null" type="button" class="btn btn-flat btn-sm btn-danger" id="remove" @click="remove('Remove',item.id)">Remove</button>
                                    </td>
                                </tr>
                                <tr id="option">
                                    <td>
                                        <select name="dzongkhag" @change="getschoolList('dzongkhag'),removeerror('dzongkhag')"  :class="{ 'is-invalid': student_form.errors.has('dzongkhag') }" v-model="student_form.dzongkhag" class="form-control" id="dzongkhag">
                                            <option value="">--- Please Select ---</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                        </select>
                                        <has-error :form="student_form" field="dzongkhag"></has-error>
                                    </td>
                                    <td>
                                        <select v-model="student_form.school" :class="{ 'is-invalid': student_form.errors.has('school') }" @change="removeerror('school')" class="form-control" name="school" id="school">
                                            <option value="">--- Please Select---</option>
                                            <option v-for="(item, index) in schoolList" :key="index" v-bind:value="item.id">{{item.name}} {{item.Level}}</option>
                                        </select>
                                        <has-error :form="student_form" field="school"></has-error>
                                    </td>
                                    <td>
                                        <span>{{this.std_class}}</span>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="card-footer text-right" id="btn">
                            <button type="button" class="btn btn-flat btn-sm btn-primary" id="addMore" @click="addMore()"><i class="fa fa-plus"></i>Submit</button>
                        </div>
                        <div class="alert alert-info alert-dismissible" id="message">
                            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                            <h5><i class="icon fas fa-exclamation-triangle"></i> Information!</h5>
                            <div id="message"></div>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
            schoolAdmissionDateValidation:'',
            eccdAdmissionDateValidation:'',
            is_student:false,
            std_id:'',
            std_class:'',
            std_present_class:'',
            std_present_school:'',
            level:'',
            org_id:'',
            is_valid_age:'',
            adm_start_date:'',
            adm_end_date:'',
            parent_school_dzongkhag:'',
            genderArray:{},
            dzongkhagArray:{},
            gewogArray:{},
            villageArray:{},
            OrgDetails:'',
            dzongkhagList:[],
            schoolList:[],
            classList:[],
            streamList:[],
            stdList:[],
            std_admission_details:'',
            ppdob:'',
            eccddob:'',
            ppmonth:'',
            eccdmonth:'',
            response_data:[],
            parents_details:'',
            //prefedined an array of the classes
            class_array:['AGE 1','AGE 2','AGE 3','AGE 4','AGE 5','PP', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
            student_form: new form({
                id:'',
                seats:0,
                student:'',
                Application_type:'Portal',
                student_id:'',
                dzongkhagName:'',
                school:'',
                class:'',
                dateOfapply:'',
                remarks:'',
                std_decission:'',
                admission_from:'Online',
                actiontype:'portal'
            })
        }
    },
    methods:{
        async CheckConfiguration(uri="CheckConfiguration/admission"){
            axios.get(uri)
            .then(response => {
                let data = response.data;
                this.status =data.status;
                if(this.status==0){
                    $('#option').hide();
                    $('#btn').hide();
                    $('#message').html("<b style='color:red'>Window for applying new school is currently closed. Thank You</b>");
                    
                }
                else{
                    $('#option').show();
                    $('#btn').show();
                    $('#message').hide();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        async getStuentparentDetails(id){
            await axios.get('admissions/getStuentparentDetails/'+id+'__newDetails')
            .then(response => {
                let data = response.data;
                if(data!="" && data!=null && data!=undefined){
                    this.parents_details=data;
                }
            })
            .catch(function (error) {
                console.log("Error......"+error)
            });
        },
        async addMore(){
            let is_valid_age =true;
            let orgId=this.student_form.school;
            await axios.get('/admissions/checkSchoolLevelByOrgId/'+orgId)
            .then(Response =>{
                if(Response!=null && Response!=""){
                    let level = JSON.stringify(Response.data[0].name);
                    let dob = this.std_admission_details.DateOfBirth;
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    let date1 = new Date(dob);
                    let date2 = '';
                    if(level.includes('Early Child Care')){
                        date2 = new Date(this.eccdAdmissionDateValidation);
                    } else {
                        date2 = new Date(this.schoolAdmissionDateValidation);
                    }
                    const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

                    let age = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
                    if(level.includes('Early Child Care')){
                        if(age <=1096){
                            is_valid_age = false;
                        }
                    } else {
                        if(age <=1825){
                            is_valid_age = false;
                        }
                    }
                    if(!is_valid_age){
                        $('#addMore').hide();
                        let text = 'Child does not meet the Minimum age requirement for Admission';
                        this.showErrorMsg(text);
                    }
                    if(is_valid_age){
                        Swal.fire({
                            text: "Are you sure you wish to save this details ?",
                            icon: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes!',
                        }).then((result) => {
                            if(result.isConfirmed){
                                this.student_form.class = this.std_class;
                                this.student_form.post('/admissions/saveorgclassDetails')
                                .then((response) => {
                                    let data = response.data;
                                    let status = data.Status;
                                    if(status.match("Submitted")){
                                        this.loadadmissions(data.StdAdmissionsId);
                                        let message="You have applied to school successfully";
                                        this.$router.push({name:'apply_for_school_ackowlegement',params: {data:message}});
                                    }
                                    if(data.match("applied")){
                                    Swal.fire({
                                    text: "You have already applied to the selected school, Please check on the applied school lists above",
                                    icon: 'warning',
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Okay!',
                                    });
                                    this.$router.push('/request_for_admission_index');
                                    }
                                    this.student_form.dzongkhag='';
                                    this.student_form.school='';
                                    this.student_form.class='';
                                    this.loadadmissions(response.data.StdAdmissionsId);
                                })
                                .catch((error) => {
                                    console.log("Error addMore:"+error);
                                })
                            }
                        });
                        $('#addMore').show();
                    }
                }
            }).catch(error => console.log(error));
        },
        showErrorMsg(text){
            Swal.fire({
                html: text,
                icon: 'error'
            });
        },
        loadAdmissionDateValidation(){
            let uri='masters/loadValidationcondition';
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                this.schoolAdmissionDateValidation  = data.date1;
                this.eccdAdmissionDateValidation  = data.date;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });

        },
    
        loadAdmissionDates(classId){
            axios.get('masters/loadAdmissionDates/'+classId)
            .then(response =>{
                let data = response.data.data[0];
                if(data!=null || data!=""){
                    let admissionType = data.type; 
                    if(admissionType.includes('Admission (General)')){
                        let from_date = data.from_date;
                        let to_date = data.to_date;
                        var today = new Date();
                        let month=today.getMonth()+1;
                        if(month.toString().length==1){
                            month='0'+month;
                        }
                        var present_date = today.getFullYear()+'-'+month+'-'+today.getDate();
                        if(to_date >= present_date && from_date <= present_date){
                            $('#selectschool').show();
                            $('#finalbtn').show();
                            $('#validationmessages').hide();
                        }else{
                            let messages="The Admission Dates are closed. <br> Thank You!";
                            $('#dzo_Section').hide();
                            $('#seatAvailable').hide();
                            $('#selectschool').hide();
                            $('#main_form').hide();
                            $('#main1').hide();
                            $('#validation_message').html(messages);
                            $('#screenPermission').show();
                        }
                    }
                }
                
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        loadadmissions(id){
            this.student_form.student_seats=[];
            axios.get('/admissions/getorgclassDetails/'+id)
            .then(Response =>{
                if(Response!=null && Response!=""){
                    let data = Response.data;
                    this.response_data=data;
                    if(data.length>0){
                        $('#finalbtn').show();
                    }
                    if(data[0].school_decision=='Accepted' && data[0].student_decision=='Accepted' ){
                        // $('#actionButton').hide();
                        // $('#actionButtonHeader').hide();
                        $('#addMore').hide();
                        
                    }
                    this.loadAdmissionDates(data[0].class_id);
                    }
            }).catch(error => console.log(error));
        },

        /**
         * method to remove fields
         */
        remove(type,id){
            Swal.fire({
                text: "Are you sure you wish to take this action ?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('/admissions/deleteclassDetails/'+id+'__'+type)
                    .then((response) => {
                        let data=response.data;
                        if(data.includes('Accepted')){
                            let message="Your decision of accepting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                        }
                        else if(data.includes('Rejected')){
                            let message="Your decision of rejecting for selected school has been updated successfully<br /> Thank  you!";
                            this.$router.push({name:'acknowledgement',params: {data:message}});
                        }else{
                           this.loadadmissions(this.student_form.student_id);
                        }
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },
        loadStudentList(param){
            this.stdList =[];
            let uri="";
                uri='admissions/loadStudentList/'+param;
                axios.get(uri)
                .then(response => {
                    let data = response.data.data;
                    this.stdList = data;
                });
            },

        getdzongkhagList(type){
            let uri ='masters/loadGlobalMasters/all_active_dzongkhag';
            axios.get(uri)
            .then(Response =>{
                let data = Response.data.data;
                this.dzongkhagList = data;
                for(let i=0;i<data.length;i++){
                    this.dzongkhagArray[data[i].id] = data[i].name;
                }
                $('#dzongkhag').prop('disabled',false);
            }).catch(error => console.log(error));
        },

        getParentSchoolDzo(){
            this.student_form.dzongkhag = this.parent_school_dzongkhag;
            $('#dzongkhag').prop('disabled',true);
            this.getParentSchoolList(this.org_id);
        },

        getstudentPersonalDetails(type){
            axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != ""){
                    this.DateOfBirth = data.DateOfBirth;
                    this.getOrgDetails(data.OrgOrganizationId)
                    this.std_admission_details=data;
                    this.std_admission_details.class =data.class_id;
                    this.org_id = this.std_admission_details.OrgOrganizationId;

                    //Function to load the school list as per feeders
                    if(type == 'Student'){
                        let uri2 ='organizations/loadOrganizationDetailsbyOrgId/'+this.org_id;
                        axios.get(uri2)
                        .then(Response =>{
                            let dzongkhag_data = Response.data.data;
                            this.parent_school_dzongkhag = dzongkhag_data.dzongkhagId;
                            this.std_present_school = dzongkhag_data.name;
                            this.level=dzongkhag_data.level_name;
                            this.student_form.dzongkhag = this.parent_school_dzongkhag;
                            $('#dzongkhag').prop('disabled',true);
                            this.getStudentClass(data.id);
                            this.getParentSchoolList(this.org_id);
                        }).catch(error => console.log(error));

                        this.student_form.student_id=data.id;
                        this.loadadmissions();
                        let AdmissionType='ParentSchool';
                        this.student_form.admission_type=AdmissionType;
                        $("input[name=registrationType][value=" + AdmissionType + "]").prop('checked', true);
                    } else {
                        this.student_form.student_id=data.id;
                        this.std_class=data.class_id;
                        this.loadadmissions();
                        this.student_form.admission_type=data.AdmissionType;
                        $("input[name=registrationType][value=" + data.AdmissionType + "]").prop('checked', true);
                    }
                    
                    this.showsection(data.AdmissionType)
                    this.getGewogList(data.CmnDzoId,data.CmnGewogId);
                    this.getvillagelist(data.CmnGewogId,data.CmnChiwogId);
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });
        },

        getStudentClass(std_id){
            let uri = '/students/getStudentClassId/'+ std_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    //have to check whether the student passed or failed
                    this.std_present_class = data.class;
                    let index = this.class_array.indexOf(this.std_present_class);
                    index++;
                    this.std_class=this.class_array[index];
                    this.classList.push(this.std_class);
                    $('#classsection').show();
                    this.loadAdmissionDates(this.std_class);
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },

        getParentSchoolList(org_id){
            // this.schoolList=[];
            let uri = '/organizations/loadParentSchoolList/'+ org_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    this.schoolList=data;
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },

        getclassList(id){
            this.classList =[];
            let orgId=$('#'+id).val();
            let schoolValue = this.checkSchoolList(orgId);
            if(schoolValue){
                this.student_form.school=orgId;
                axios.get('/masters/loadClassStreamSection/NA/' +orgId)
                .then(Response =>{
                    let data = Response.data;
                    let type=$('input[name="registrationType"]:checked').val();
                    this.student_form.admission_type=type;
                    if(type=="PP"){
                        data.forEach(cls => {
                            if(cls.class=='PP'){
                                this.classList.push(cls);
                            }
                        });
                    }
                    else{
                        this.classList = data;
                    }
                    $('#classsection').show();

                })
            } else {
                Swal.fire({
                    text: "This selection has already been added",
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ok!',
                })
                this.student_form.school = '';
            }
        },

        checkSchoolList(orgId){
            for(let i=0;i<this.response_data.length;i++){
                if(this.response_data[i].organization.id == orgId){
                    return false;
                }
            }
            return true;
        },

        getstreamListByid(id){
            let classId=$('#class').val();
            if(id!=""){
                classId=id;
            }
            axios.get('/masters/getStreamByclassId/' +classId)
            .then(Response =>{
                let data = Response.data;
                this.classList = data;
            })
        },

        getOrgDetails(id){
            axios.get('/organizations/loadOrganizationDetailsbyOrgId/' +id)
            .then(response =>{
                let data = response.data.data;
                if(data!="" ||data!=null){
					this.student_form.dzongkhagName=data.dzongkhag;
					this.student_form.gewog=data.gewog;
					this.student_form.chewog=data.chewog;
				}	
            })

        },

        getGewogList(dzongkhag,gewog_id){
            let uri = 'masters/all_active_dropdowns/dzongkhag/'+dzongkhag;
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.gewogArray[data[i].id] = data[i].name;
                }
                $('#gewogid').html(this.gewogArray[gewog_id]);
            });
        },

        getvillagelist(gewogId,vilId){
            let uri = 'masters/all_active_dropdowns/gewog/'+gewogId;
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                for(let i=0;i<data.length;i++){
                    this.villageArray[data[i].id] = data[i].name;
                }
                $('#vilageId').html(this.villageArray[vilId]);
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        applyselect(){
            if(!$('#dzongkhag').attr('class').includes('select2')){
            $('#dzongkhag').addClass('select2');
            }
            if(!$('#school').attr('class').includes('select2')){
            $('#school').addClass('select2');
            }
            if(!$('#class').attr('class').includes('select2')){
            $('#class').addClass('select2');
            }
            if(!$('#stream').attr('class').includes('select2')){
            $('#stream').addClass('select2');
            }
        },
        loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        removeerror(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        },

        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="class"){
                this.student_form.class=$('#class').val();

            }
            if(id=="stream"){
                this.student_form.stream=$('#stream').val();
                // this.getstreamList($('#stream').val);
            }
            if(id='student_id'){
            //   this.student_form.student_id=$('#student_id').val();
            //   this.getstudentBasicDetailsForPortal(this.student_form.student_id);
                this.loadadmissions(this.student_form.student_id);
            }
        },
        getstudentBasicDetailsForPortal(id){
            axios.get('/admissions/getstudentBasicDetailsForPortal/'+id)
                .then(response => {
                let data = response.data;
                if(data != ""){
                    this.std_admission_details=data;
                    this.std_class=data.class_id;
                    this.org_id = this.std_admission_details.OrgOrganizationId;

                    let role = data.class_id;
                    if(role.match("AGE")){
                        this.showsection('ECCD')
                        this.loadAdmissionDates(data.class_id);
                    }
                    else{
                        this.showsection('PP')
                    }
                }
                else{
                    $('#main_form').hide();
                    $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                    $('#screenPermission').show();
                }
            });

        },
        getschoolList(dzo_id){
            this.student_form.dzongkhag=$('#'+dzo_id).val();
            var type;
            if(this.is_student){
                type = this.std_class;
            } 
            if(this.std_class == ''){
                    this.std_class=this.student_form.class;
                    type = 'General';
                    this.std_class = 'General';
                }
            else{
                type=$('input[name="registrationType"]:checked').val();
            }
            this.schoolList=[];
            //added if condition by tshewang to get school list, once student type is chaged to student. school list is not appearing as type is empty
            if(type==""){
                type = this.std_class;
            }
            // let uri = '/organizations/loadSchoolList/'+ $('#'+dzo_id).val()+'/'+type;
            let uri = '/organizations/loadSchoolListForPortal/'+ $('#'+dzo_id).val()+'/'+type+'/'+this.std_class;
            try{
                axios.get(uri).then(response => {
                    let data= response.data;
                    if(data!='' && data!=null){
                        this.schoolList=data;
                        $('#school_Section').show();
                    }
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },
        getProjection(){
            if($('input[name="registrationType"]:checked').val()=="PP"){
                let clasId=$('#class').val();
                let orgId=$('#school').val();
                let uri = '/organizations/loadProjection/'+clasId+'__'+orgId;
                axios.get(uri).then(response => {
                    let data= response.data;
                    this.student_form.seats=data.ProjectionNo;
                });
            }
            else{
                $('#seatAvailable').hide();
            }
        },
        loadVlidation(){
            let uri='masters/loadValidationcondition';
            axios.get(uri)
            .then(response =>{
                let data = response.data.data;
                this.ppdob=data.date;
                this.eccddob=data.date1;
                this.ppmonth=data.no_months;
                this.eccdmonth=data.no_months1;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });
        },
        showsection(type){
            let dob=new Date(this.std_admission_details.DateOfBirth);
            // let year2=date2.getFullYear();
            // let month2=date2.getMonth();
            // let numberOfMonths;
            let isvalid=true;
            let messages="";
            if(this.is_student){
                $('#selectschool').show();
                $('#validationmessages').hide();
            } else {
                if(type=="ECCD"){
                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    let dob=this.std_admission_details.DateOfBirth;
                    let date1 = new Date(dob);
                    let date2 = new Date(this.eccddob);

                    // Discard the time and time-zone information.
                    const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

                    let eecdage = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
                    if(eecdage <=1096){
                        messages="You need to attained the minimum required age";
                        $('#dzo_Section').hide();
                        $('#seatAvailable').hide();
                        $('#selectschool').hide();
                        $('#validation_message').html(messages);
                        $('#validationmessages').show();
                    } else {
                        $('#selectschool').show();
                        $('#finalbtn').show();
                        $('#validationmessages').hide();
                    }
                }
                else{
                    axios.get('masters/loadGlobalMasters/admission')
                    .then(response => {
                        let data = response.data.data;
                        if(data!=null){
                            let from_date = new Date(data.from_date);
                            let to_date = new Date(data.to_date);
                            let present_date = new Date();
                            if(to_date >= present_date && from_date <= present_date){
                                $('#selectschool').show();
                                $('#finalbtn').show();
                                $('#validationmessages').hide();
                            }else{
                                $('#addMore').hide();
                                let messages="The Admission Dates are closed. <br> Thank You!";
                                $('#dzo_Section').hide();
                                $('#seatAvailable').hide();
                                $('#selectschool').hide();
                                $('#validation_message').html(messages);
                                $('#validationmessages').show();
                            }
                        }
                    })
                    .catch(errors => {
                        console.log(errors)
                    });

                    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                    let dob=this.std_admission_details.DateOfBirth;
                    let date1 = new Date(dob);
                    let date2 = new Date(this.ppdob);

                    // Discard the time and time-zone information.
                    const dob_date = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
                    const admission_date = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

                    let ppage = Math.floor((admission_date-dob_date) / _MS_PER_DAY);
                    if(ppage <=1825){
                        messages="You need to attained the minimum required age";
                        $('#dzo_Section').hide();
                        $('#seatAvailable').hide();
                        $('#selectschool').hide();
                        $('#validation_message').html(messages);
                        $('#validationmessages').show();
                    } else {
                        $('#selectschool').show();
                        $('#validationmessages').hide();
                    }
                }
            }
        }
    },
    async mounted() {
        //added for timebeing until new window is set up
        // let messages="The Admission Dates for applying new school is closed. <br> Thank You!";
        // $('#message').html(messages);
        // $('#screenPermission').show();
        // $('#option').hide();
        // $('#btn').hide();
        
        this.getdzongkhagList();
        //this.getParentSchoolDzo();
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
            this.loadStudentList(this.userId)
            this.std_id=data['std_id'];
            // this.getStuentparentDetails(this.std_id);
            let user_type=data['user_type'];
            if(data['user_type']!="Parent"){
                this.is_student=true;
                this.getstudentPersonalDetails(user_type);
            }
            else{
                $('#present_school').hide();
                $('#pheader').hide();
                // $('#admissiontype').hide()
                
            }
            this.getdzongkhagList(user_type);
        })
        .catch(errors => {
            console.log(errors)
        });

        $('.select2').select2({
        theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });
        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        // this.loadAdmissionDates();
        this.CheckConfiguration();
        this.loadAdmissionDateValidation();
        this.loadVlidation();
        this.loadGenderList();
        if(this.$route.params.data!=undefined){
            this.getstudentBasicDetailsForPortal(this.$route.params.data.id);
            this.getStuentparentDetails(this.$route.params.data.id);
            this.loadadmissions(this.$route.params.data.id);
            this.student_form.student_id=this.$route.params.data.id;
            this.student_form.class=this.$route.params.data.class_id;
            if(this.student_form.class.match("AGE")){
                this.student_form.admission_type='ECCD';
                $('#new').prop('disabled',true);
                $('#existing').prop('disabled',true);
            }
            else{
                this.student_form.admission_type='PP';
                $('#new').prop('disabled',true);
                $('#existing').prop('disabled',true);
            }
            
        }
      

    },
}
</script>
